import React, { useState } from "react";

const NotificationContext = React.createContext()

function NotificationProvider( { children } ) {
    const [notification, setNotification] = useState({
        open: false,
        message: null
    });

    return (
        <NotificationContext.Provider value={ { notification, setNotification } }>
            { children }
        </NotificationContext.Provider>
    )
}

export { NotificationContext, NotificationProvider }